import React from 'react'

import { H4 } from 'components/heading/Heading'

import { CheckLarge } from '../check-large/CheckLarge'

import s from './FindAddressResults.module.scss'

type PropertyOfOtherKind = {
  selected: boolean
  propertyNumber: string
  apartmentNumber: string
  size: string | number
}

type SearchResults = Array<{
  address: string
  postalCode: string
  neighborhood: string
  properties: Array<PropertyOfOtherKind>
}>

type Props = {
  results: SearchResults
  toggleProperty: (resultIndex: number, propertyIndex: number) => void
}

export const FindAddressResults = ({ results, toggleProperty }: Props) => {
  return (
    <div className={s.addresspickerresults}>
      {results.map((item, resultsIndex) => (
        <div key={resultsIndex} className={s.addresspickerresults__container}>
          <H4 className={s.addresspickerresults__title}>
            {item.address}, {item.postalCode} {item.neighborhood}
          </H4>

          <ul className={s.addresspickerresults__list}>
            <li className={s.addresspickerresults__col}>Fasteign</li>
            <li className={s.addresspickerresults__col}>Eignanúmer</li>
            <li className={s.addresspickerresults__col}>Stærð</li>
          </ul>

          {item.properties.map((property, i) => (
            <CheckLarge
              key={i}
              name="address"
              value="item.address"
              className={s.addresspickerresults__check}
              defaultChecked={property.selected}
              label={
                <div className={s.addresspickerresults__property}>
                  <span className={s.addresspickerresults__id}>
                    {property.propertyNumber}
                  </span>
                  <span className={s.addresspickerresults__number}>
                    {property.apartmentNumber.substring(3)}
                  </span>
                  <span className={s.addresspickerresults__size}>
                    {property.size} m<sup>2</sup>
                  </span>
                </div>
              }
              onChange={(e) => {
                toggleProperty(resultsIndex, i)
              }}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
